import {Base} from "@/api/Base"

export class AdvisorOverrideAdd extends Base {
    path = "advisorOverride/add"
}